var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[(_vm.isAuthenticated)?[_c('navbar',{class:_vm.navbarClass}),_c('page',{class:_vm.pageClass})]:_c('router-view',{staticClass:"dashboard__login"}),_c('svg-icons',{staticClass:"dashboard__icons"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }